import { render, staticRenderFns } from "./ChimelongNewAccount.vue?vue&type=template&id=1be4c8ff&scoped=true"
import script from "./ChimelongNewAccount.vue?vue&type=script&lang=js"
export * from "./ChimelongNewAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be4c8ff",
  null
  
)

export default component.exports